import * as React from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { Base } from "ui/Scripts/source/framework/base";
import { IEventListItem } from "../../models/event/eventListItem";
import { SubPageHeader } from "../app/header";
import * as store from "../../framework/customStore";
import * as storeTypes from "../../models/store/storeTypes";
import * as baseService from "../../models/services/baseService";
import * as eventService from "../../models/services/eventService";
import * as storeActions from "../../models/store/storeActions";
import { EventListSearchDialog } from "./eventListSearch";
import { customHistory } from "../../framework/customHistory";
import { Session } from "../../models/session/session";
import { EventListLine } from "./eventListLine";
import { ActivePageType, NavigationBar } from "../app/navigation";
import { IUnitItem } from "../../models/unit/unitItem";
import { IUserState } from "../../models/store/storeTypes";

//EventListMenu
export interface IEventListMenuProp {
    item: IEventListItem;
    onEdit: () => void;
    onPrint: () => void;
    onRemove: () => void;
    onCancel: () => void;
}

export class EventListMenu extends React.Component<IEventListMenuProp, {}> {
    handleEditClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onEdit();
    };

    handlePrintClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onPrint();
    };

    handleRemoveClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onRemove();
    };

    handleCancelClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.props.onCancel();
    };
        
    render() {
        const item = this.props.item;
        if (Base.isNullOrUndefined(item)) return null;
        return (
            <div className="listPopupMenu" onClick={this.handleCancelClick}>
                <div className="menu">
                    <div className="line" onClick={this.handleEditClick}>{Translations.Edit}</div>
                    <div className="line" onClick={this.handlePrintClick}>{Translations.Print}</div>
                    <div className={"line" + (item.removable && !item.locked ? "" : " disabled")} onClick={item.removable ? this.handleRemoveClick : null}>{Translations.Remove}</div>
                    <div className="line" onClick={this.handleCancelClick}>{Translations.Cancel}</div>
                </div>
            </div>
        );
    }
}

//EventList
export interface IEventListOwnProps {
}

export interface IEventListStateProps {
    user: IUserState;
    hasMore: boolean;
    isLoading: boolean;
    page: number;
    items: IEventListItem[];
    state: number;
    startDate: number;
    endDate: number;
    unitId: string;
    units: IUnitItem[];
    sortColumn: string;
    lastOpenedEventId: string;
}

export interface IEventListDispatchProps {
    loadEvents: (page: number, state: number, startDate: number, endDate: number, unitId: string) => void;
    removeEvent: (id: string) => void;
    resetEvents: () => void;
    refreshEvents: (page: number, state: number, startDate: number, endDate: number, unitId: string) => void;
    setLastOpenedEventId: (id: string) => void;
    setReturnUrl: (url: string) => void;
    onLogout: () => void;
}

type EventListProp = IEventListOwnProps & IEventListStateProps & IEventListDispatchProps;

interface IEventListState {
    selectedId: string;
    showListMenu: boolean;
    showSearchDialog: boolean;
    listMenuItem: IEventListItem;
    companyName: string;
}

export class EventList extends React.Component<EventListProp, IEventListState> {
    private hasBeenInitialized: boolean;
    private containerDiv: HTMLDivElement;
    private listDiv: HTMLDivElement;
    private companyLogo: string;

    constructor(props) {
        super(props);
        this.hasBeenInitialized = false;
        this.state = { selectedId: null, showListMenu: false, showSearchDialog: false, listMenuItem: null, companyName: "" };
    }

    handleScrollSub = Base.debounce((obj) => {
        if (obj.props.isLoading || !obj.props.hasMore || !obj.listDiv || !obj.containerDiv) return;
        if (obj.listDiv.offsetHeight - (obj.containerDiv.clientHeight + obj.containerDiv.scrollTop) < 5) {
            obj.props.loadEvents(obj.props.page + 1, this.props.state, this.props.startDate, this.props.endDate, this.props.unitId);
        }
    }, 100);

    handleScroll = (event) => {
        this.handleScrollSub(this);
    };

    handleLineLongPress = (id: string) => {
        const listMenuItem = this.props.items.find(i => i.id === id);
        if (Base.isNullOrUndefined(listMenuItem)) return;
        this.setState({
            selectedId: id,
            showListMenu: true,
            listMenuItem
        });
    };

    handleRefreshList = () => {
        this.props.refreshEvents(this.props.page, this.props.state, this.props.startDate, this.props.endDate, this.props.unitId);
    };

    componentDidMount(): void {
        this.containerDiv.addEventListener("scroll", this.handleScroll);
        if (this.props.page === 0) { //First load
            this.props.loadEvents(1, this.props.state, this.props.startDate, this.props.endDate, this.props.unitId);
        } else { //Event edit back button
            this.props.refreshEvents(this.props.page, this.props.state, this.props.startDate, this.props.endDate, this.props.unitId);
        }
        //Scroll last opened item to view
        if (this.props.items.length > 0 && !Base.isNullOrEmpty(this.props.lastOpenedEventId)) {
            if (this.containerDiv.scrollTo !== null && this.containerDiv.scrollTo !== undefined) {
                const index = this.props.items.findIndex(i => i.id === this.props.lastOpenedEventId);
                if (index > -1) {
                    const elements = this.containerDiv.getElementsByClassName("loe");
                    if (elements.length > 0 && !Base.isNullOrUndefined(elements[0])) {
                        const y = (elements[0] as HTMLDivElement).offsetTop;
                        this.containerDiv.scrollTo({
                            top: y,
                            left: 0,
                            behavior: "auto"
                        });
                    }
                }
            }
            this.props.setLastOpenedEventId("");
        }
        //Set companyName
        Session.getCompanyName().then((companyName) => {
            this.setState({
                companyName
            });
        });
        //Set companyLogo
        Session.getCompanyLogo().then((companyLogo) => {
            this.companyLogo = companyLogo;
        });
        this.hasBeenInitialized = true;
    }

    componentWillUnmount(): void {
        this.containerDiv.removeEventListener("scroll", this.handleScroll);
        this.props.resetEvents();
    }

    createPrint = () => {
        if (Base.isNullOrEmpty(this.state.selectedId)) return;
        const event = this.props.items.find(i => i.id === this.state.selectedId);
        if (Base.isNullOrUndefined(event)) return;
        store.customStore.dispatch(storeActions.showInfoMessage(Translations.CreatingPrint));
        eventService.printEvent(event.id, event.name)
            .then(() => {
                store.customStore.dispatch(storeActions.clearInfoMessage());
            })
            .then(fileName => {
                store.customStore.dispatch(storeActions.showSuccessMessage(String.format(Translations.PrintParameterDownloaded, fileName)));
            }).catch(error => {
                store.customStore.dispatch(storeActions.clearInfoMessage());
                store.customStore.dispatch(storeActions.showErrorMessage(baseService.getErrorMessageFromError(error)));
            });
    };

    removeEvent = () => {
        const obj = this;
        if (Base.isNullOrEmpty(this.state.selectedId)) return;
        const event = this.props.items.find(i => i.id === this.state.selectedId);
        if (Base.isNullOrUndefined(event)) return;
        store.customStore.dispatch(storeActions.setConfirmation(storeTypes.ConfirmationDialogType.Warning, Translations.RemoveEvent, String.format(Translations.DoYouReallyWantToRemoveEventParameter, event.name),
            () => {
                store.customStore.dispatch(storeActions.clearConfirmation());
                store.customStore.dispatch(storeActions.fetchStart());
                eventService.removeEvent(event.id)
                    .then(success => {
                        store.customStore.dispatch(storeActions.showSuccessMessage(success.message));
                        obj.props.removeEvent(event.id);
                        obj.props.refreshEvents(obj.props.page, obj.props.state, obj.props.startDate, obj.props.endDate, obj.props.unitId);
                    })
                    .catch(error => {
                        store.customStore.dispatch(storeActions.showErrorMessage(baseService.getErrorMessageFromError(error)));
                        return null;
                    })
                    .finally(() => store.customStore.dispatch(storeActions.fetchEnd()));
            },
            () => {
                store.customStore.dispatch(storeActions.clearConfirmation());
            }));
    };

    setReturnUrl = () => {
        this.props.setReturnUrl("/event");
    };

    handleLineClick = (id: string) => {
        this.props.setLastOpenedEventId(id);
        this.setReturnUrl();
        customHistory.push("/event/" + id);
    };

    handleAddClick = () => {
        this.props.setLastOpenedEventId("");
        this.setReturnUrl();
        customHistory.push("/event/" + Base.emptyGuid);
    };

    handleMenuEdit = () => {
        this.props.setLastOpenedEventId(this.state.selectedId);
        this.setReturnUrl();
        customHistory.push("/event/" + this.state.selectedId);
        this.setState({
            showListMenu: false
        });
    };

    handleMenuPrint = () => {
        this.setState({
            showListMenu: false
        });
        this.createPrint();
    };

    handleMenuRemove = () => {
        this.setState({
            showListMenu: false
        });
        this.removeEvent();
    };

    handleMenuCancel = () => {
        this.setState({
            showListMenu: false
        });
    };

    handleSearchEvents = () => {
        this.setState({
            showSearchDialog: true
        });
    };

    handleSearchDialogOk = (state: number, startDate: number, endDate: number, unitId: string) => {
        this.setState({
            showSearchDialog: false
        });
        this.props.refreshEvents(1, state, startDate, endDate, unitId);
    };

    handleSearchDialogCancel = () => {
        this.setState({
            showSearchDialog: false
        });
    };

    getListTitleSuffix = (state: number, startDate: number, endDate: number) => {
        let result = (state === 0
            ? ""
            : (state === 1
                ? Translations.NotApproved
                : (state === 2
                    ? Translations.Approved
                    : (state === 3
                        ? Translations.Draft
                        : (state === 4
                            ? Translations.NotAssigned
                            : (state === 5
                                ? Translations.StateOpen
                                : Translations.Closed))))));
        if (!Base.isNullOrUndefined(startDate) && !Base.isNullOrUndefined(endDate)) {
            result = result + (!Base.isNullOrEmpty(result) ? ", " : "") + Base.timeToDateStr(startDate) + "->" + Base.timeToDateStr(endDate);
        } else if (!Base.isNullOrUndefined(startDate)) {
            result = result + (!Base.isNullOrEmpty(result) ? ", " : "") + Base.timeToDateStr(startDate) + "->";
        } else if (!Base.isNullOrUndefined(endDate)) {
            result = result + (!Base.isNullOrEmpty(result) ? ", " : "") + "->" + Base.timeToDateStr(endDate);
        }
        if (!Base.isNullOrEmpty(result)) {
            result = " - " + result;
        }
        return result;
    };

    render() {
        const props = this.props;
        const state = this.state;
        const firstIndex = props.items.length > 0 ? props.items.findIndex(i => !i.isTitle) : -1;
        return (
            <div>
                <div className="pageContentContainer">
                    <div className="eventListContainer mainListContainer" ref={(elem) => { this.containerDiv = elem; }}>
                        <div className="lineContainer mainLineContainer eventList" ref={(elem) => { this.listDiv = elem; }}>
                            {this.hasBeenInitialized && !props.isLoading && props.items.length < 1 &&
                                <div className="infoContainer">
                                    <div className="alert alert-info" role="alert" dangerouslySetInnerHTML={ { __html: Translations.NoEventsToShow } } />
                                </div>
                            }
                            {props.items.map((item, index) => (
                                <EventListLine
                                    key={item.id}
                                    item={item}
                                    selected={state.selectedId === item.id}
                                    first={index === firstIndex}
                                    isLastOpenedEvent={item.id === props.lastOpenedEventId}
                                    onClick={this.handleLineClick}
                                    onLongPress={this.handleLineLongPress}
                                    onRefreshList={this.handleRefreshList}
                                />
                            ))}
                        </div>
                    </div>
                </div>
                {state.showListMenu &&
                    <EventListMenu
                        item={state.listMenuItem}
                        onEdit={this.handleMenuEdit}
                        onPrint={this.handleMenuPrint}
                        onRemove={this.handleMenuRemove}
                        onCancel={this.handleMenuCancel}
                    />
                }
                {state.showSearchDialog &&
                    <EventListSearchDialog
                        state={props.state}
                        startDate={props.startDate}
                        endDate={props.endDate}
                        unitId={props.unitId}
                        units={props.units}
                        companyLogo={this.companyLogo}
                        onOk={this.handleSearchDialogOk}
                        onCancel={this.handleSearchDialogCancel}
                    />
                }
                <NavigationBar
                    activePage={ActivePageType.Event}
                    user={props.user}
                />
                <SubPageHeader
                    user={props.user}
                    title={Translations.Events + this.getListTitleSuffix(props.state, props.startDate, props.endDate)}
                    searchIsSet={props.state !== 0 || !Base.isNullOrUndefined(props.startDate) || !Base.isNullOrUndefined(props.endDate) || !Base.isNullOrUndefined(props.unitId)}
                    onSearch={this.handleSearchEvents}
                    onAdd={this.handleAddClick}
                />
            </div>
        );
    }
}